import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  envelope: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'envelope' }),
}

export { paths }
